import React, { Component } from 'react';
//import logo from './logo.svg';
import './App.css';
//import { BrowserRouter, Route, Link } from 'react-router-dom';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import Navbar from './components/layout/navbar';
import Landing from './components/layout/landing';
import Ent1 from './components/layout/ent1';
import Ent2 from './components/layout/ent2';
import Ent3 from './components/layout/ent3';
import Sci1 from './components/layout/sci1';
import Sci2 from './components/layout/sci2';
import Sci3 from './components/layout/sci3';
import Hum1 from './components/layout/hum1';
import Hum2 from './components/layout/hum2';
import Hum3 from './components/layout/hum3';
import Test from './components/layout/test';
import Gen2 from './components/layout/gen2';
import Gen3 from './components/layout/gen3';
import Oth1 from './components/layout/oth1';
import Oth2 from './components/layout/oth2';
import Oth3 from './components/layout/oth3';
import Footer from './components/layout/footer';

const supportsHistory = 'pushState' in window.history;

class App extends Component {
  render() {
    return (
    <BrowserRouter forceRefresh={supportsHistory}>
    <div className="App">
              
        <Navbar />
	    <Switch>
            <Route exact path="/" component={Landing}/>
	        <Route path="/ent1" component={Ent1}/>
	        <Route path="/ent2" component={Ent2}/> 
	        <Route path="/ent3" component={Ent3}/>
	        <Route path="/sci1" component={Sci1}/> 
	        <Route path="/sci2" component={Sci2}/> 
	        <Route path="/sci3" component={Sci3}/>
	        <Route path="/hum1" component={Hum1}/> 
	        <Route path="/hum2" component={Hum2}/>
	        <Route path="/hum3" component={Hum3}/>   	       
	        <Route path="/gen1" component={Test}/>
	        <Route path="/gen2" component={Gen2}/>
	        <Route path="/gen3" component={Gen3}/>
	        <Route path="/oth1" component={Oth1}/>
	        <Route path="/oth2" component={Oth2}/>
	        <Route path="/oth3" component={Oth3}/>	        
	   </Switch>
	   <Footer />
   </div>
   </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js